<ul class="sidebar-menu nav flex-column text-center">
  <li class="nav-item" *ngFor="let item of navItems">
    <a [routerLink]="item.link"
       routerLinkActive #rla="routerLinkActive"
       [routerLinkActiveOptions]="{ exact: false }"
       class="nav-link d-flex flex-column align-items-center justify-content-center"
       [class.reports-active]="item.label === 'Reports' && isReportsActive()">
      <div class="icon-circle mb-1"
           [class.active-circle]="rla.isActive || (item.label === 'Reports' && isReportsActive())">
        <i class="{{ item.icon }}"></i>
      </div>
      <span class="label"
            [class.text-active]="rla.isActive || (item.label === 'Reports' && isReportsActive())">
        {{ item.label }}
      </span>
    </a>
  </li>
</ul>
